import { Link } from 'react-router-dom';

const credits = [
  ['App framework', 'React, React Router, and Vite'],
  ['3D and XR', 'three.js and krpano'],
  ['Maps', 'OpenStreetMap contributors and Leaflet'],
  ['Icons', 'Font Awesome and Lucide'],
];

export default function Attributions() {
  return <main className="min-h-screen bg-slate-950 px-6 py-16 text-white">
    <div className="mx-auto max-w-3xl">
      <Link to="/" className="text-cyan-300">In3D.ai</Link>
      <h1 className="mt-10 text-4xl font-bold">Attributions</h1>
      <p className="mt-4 text-white/70">Technology and data sources used by In3D.ai.</p>
      <dl className="mt-10 space-y-5">{credits.map(([name, detail]) =>
        <div key={name} className="border-b border-white/10 pb-5">
          <dt className="font-semibold">{name}</dt>
          <dd className="mt-1 text-white/65">{detail}</dd>
        </div>
      )}</dl>
      <p className="mt-10 text-white/70">For attribution questions, contact <a className="text-cyan-300" href="mailto:admin@in3d.ai">admin@in3d.ai</a>.</p>
    </div>
  </main>;
}
